import { Handler, HasOnError } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/PreloadOrderConfirmationData";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { Purchase } from "@SupplyLand/Utilities/customTracking";

type HandlerType = Handler<
    {
        cartId: string;
        onSuccess: () => void;
    } & HasOnError<string>
>;

export const TrackCheckoutProcess: HandlerType = props => {
    const state = props.getState();
    const cartState = getCartState(state, props.parameter.cartId);
    const cart = cartState.value as Cart;
    const shipToState = getShipToState(state, cart.shipToId);
    const shipTo = shipToState.value as ShipToModel;
    Purchase(cart, shipTo);
};

addToChainAfter(chain, ExecuteOnSuccessCallback, TrackCheckoutProcess);
